import { BrandIcon } from "@ui/BrandIcon";
import { Card } from "@ui/Card";
import { formatWithMagnitude } from "@ui/format";
import { MaterialSymbol } from "@ui/MaterialSymbol";
import { HStack, VStack } from "@ui/Stack";
import { Text } from "@ui/typography/Text";
import { getPlatformDisplayName } from "@utils/platform";
import { Show } from "solid-js";
import type { InfluencerPublicProfileResponse } from "@/client";
import { externalSocialProfileUrl } from "../../utils/platformPostUrl";
import { isDirectUploadPlatform } from "~/modules/shared/utils/sourceFilterOptions";

export type Platform = NonNullable<
	NonNullable<InfluencerPublicProfileResponse["influencer"]>["platforms"]
>[number];

const ProfilePanelSocialBody = (props: { platform: Platform }) => {
	const isDirectUpload = () => isDirectUploadPlatform(props.platform.platform);

	return (
		<HStack justify="space-between">
			<HStack spacing="medium">
				<div
					class={`profile-panel-channel__icon ${isDirectUpload() ? "direct-upload" : props.platform.platform}`}
				>
					<Show
						when={isDirectUpload()}
						fallback={
							<BrandIcon
								platform={props.platform.platform}
								fillWithCurrentColor
							/>
						}
					>
						<MaterialSymbol symbol="upload" />
					</Show>
				</div>
				<VStack>
					<Text size="standard" weight="bold">
						{props.platform.handle}
					</Text>
					<Text size="small" color="fg2">
						{getPlatformDisplayName(props.platform.platform)}
					</Text>
				</VStack>
			</HStack>
			<Show when={!isDirectUpload()}>
				<HStack spacing="medium">
					<Text size="standard" weight="bold" transform="uppercase" color="ink">
						{formatWithMagnitude(props.platform.follower_count)}
					</Text>
					<MaterialSymbol symbol="north_east" color="fg4" />
				</HStack>
			</Show>
		</HStack>
	);
};

export const ProfilePanelSocial = (props: { platform: Platform }) => {
	const profileHref = () =>
		externalSocialProfileUrl(
			props.platform.platform,
			props.platform.profile_url,
		);

	return (
		<Show
			when={profileHref()}
			fallback={
				<Card theme="grey" style={{ "flex-grow": 1 }}>
					<ProfilePanelSocialBody platform={props.platform} />
				</Card>
			}
		>
			{(href) => (
				<Card
					as="a"
					href={href()}
					target="_blank"
					theme="grey"
					style={{ "flex-grow": 1 }}
				>
					<ProfilePanelSocialBody platform={props.platform} />
				</Card>
			)}
		</Show>
	);
};
